export default "__VITE_ASSET__GQngezL3__"